import {Component , Vue, Watch} from "vue-property-decorator";
import { LOCALSTORAGE_AUTH2 } from "../../common/constants";

@Component({
	name: "LogmeinComponent",
	template: require("./template.html"),
})

export default class LogmeinComponent extends Vue {
    public visible: boolean = false;
    public userSession: any = {};
    lblSetting: any;

    isActiveDownload: boolean = false;
    htmlContent: string = '';

    handleClose() {
        this.visible = false;
    }
    activeDownloadForm() {
        this.isActiveDownload = true;
        this.visible = false;
    }
    private getSerialByLanguage() {
        console.log(this.$i18n.locale);
        const serial = {
            code: '1530081373',
            text: 'FR speaking'
        };
        switch(this.$i18n.locale) {
            case 'en-US':
                serial.code = '1431120463';
                serial.text = 'EN speaking';
                break;
            case 'fr-BE':
                serial.code = '1530081373';
                serial.text = 'FR speaking';
                break;
            case 'nl-BE':
                serial.code = '1419669478';
                serial.text = 'NL speaking';
                break;
            default:
                break;
        }
        return serial;
    }
    @Watch('visible')
    onChangeVisible(newVal, oldVal) {
        if (!oldVal && newVal) {
            this.isActiveDownload = false; 
        }
    }
    mounted() {
        let authData = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
        authData = authData ? JSON.parse(authData) : {} ;
		let userName = this.userSession.UserInfo.Name
        , customerName = authData && authData.information && authData.information.customerName
		, userId = this.userSession.UserInfo.Id;
		if (!customerName) {
			customerName = this.userSession.OriginDomain;
		}
        let serialByLanguage = this.getSerialByLanguage();
        this.htmlContent = `
           <form id="downloadForm" action="https://secure.logmeinrescue.com/Customer/Download.aspx" method='post'>
            <input type='hidden' name='EntryID' value='${serialByLanguage.code}' />
            <input type='hidden' name='tracking0' maxlength='64' value='' />
            <input type='text' name='name' maxlength='64' value='${userName}-${customerName}' /></td>
            <input type='text' name='comment1' maxlength='512' value='${customerName}' /></td>
            <input type='text' name='comment2' maxlength='512' value='${userId.toString()}' /></td>
            <input type='submit' value='${serialByLanguage.text}' /></td>
            </form>
            <script>
            console.log(document.forms)
            document.getElementById('downloadForm').submit();

            </script>
        `;
    }
}